import { render } from "./LivingView.vue?vue&type=template&id=1e2a16a8"
import script from "./LivingView.vue?vue&type=script&lang=js"
export * from "./LivingView.vue?vue&type=script&lang=js"

import "./LivingView.vue?vue&type=style&index=0&id=1e2a16a8&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__